import logoBlue from 'assets/images/logo-blue.svg';
import accountManagementStrings from 'modules/accountManagement/strings';
import Loader from 'modules/common/components/Loader';
import SectionDivider from 'modules/common/components/SectionDivider';

import { Wrapper, Logo, FormValidationError, FormBtn } from './LoginComponent.style';

type LoginComponentProps = {
  isAuthenticating: boolean;
  authenticationError: string;
  handleSubmitBtnClick: () => void;
};

const LoginComponent: React.FC<LoginComponentProps> = ({
  isAuthenticating,
  authenticationError,
  handleSubmitBtnClick,
}) => (
  <Wrapper>
    <Logo src={logoBlue} />
    <SectionDivider gap={80} />
    {isAuthenticating ? (
      <Loader width={60} height={60} thickness={8} />
    ) : (
      <FormBtn as="button" disabled={isAuthenticating} onClick={() => handleSubmitBtnClick()}>
        {accountManagementStrings.login.formBtnText}
      </FormBtn>
    )}
    {authenticationError && (
      <>
        <SectionDivider gap={15} />
        <FormValidationError>{authenticationError}</FormValidationError>
      </>
    )}
  </Wrapper>
);
// ###############################################################
// <----------------------- End Return UI ----------------------->
// ###############################################################

LoginComponent.defaultProps = {
  isAuthenticating: false,
  authenticationError: '',
  handleSubmitBtnClick: () => {},
};

export default LoginComponent;
